let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iGTFs")).then(() => parcelRequire('2qJyh'));